import Container__AddServiceController from "../../containers/batch_actions/add_service_controller.js"

// Referred from `app/assets/javascripts/services.js`
export default class extends Container__AddServiceController {}
